import { render, staticRenderFns } from "./left-middle.vue?vue&type=template&id=44f7a201&scoped=true&"
import script from "./left-middle.vue?vue&type=script&lang=js&"
export * from "./left-middle.vue?vue&type=script&lang=js&"
import style0 from "./left-middle.vue?vue&type=style&index=0&id=44f7a201&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f7a201",
  null
  
)

export default component.exports